/**************************************************
 * Nombre:       Formulario_Direccion_Entrega
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import { Grid, Typography} from "@mui/material";
import {
    AccountCircleOutlined,
    CakeOutlined,
    Mail,
    PhoneAndroid,
    WhatsApp,
    BadgeOutlined,
    MailOutline,
    AccountCircle,
    SmartphoneOutlined,
    FlagOutlined,
    LocationCityOutlined,
    MapsHomeWorkOutlined,
    SignpostOutlined
} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {obtenerDepartamentos} from "../../Modulo_envios/Funciones/obtenerDepartamentos";
import {useState} from "react";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {obtenerCiudades} from "../../Modulo_envios/Funciones/obtenerCiudades";


const Formulario_Direccion_Entrega = ({...props}) => {
    const [departamento, setDepartamento] = useState('')


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

               

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoSelectFuncion Icono={FlagOutlined} nombre={'Departamento'} dato={'departamento'} {...props}
                                          opciones={obtenerDepartamentos()} setDato={setDepartamento}
                                          requerido={'Campo requerido'}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoSelect Icono={LocationCityOutlined} nombre={'Ciudad'} dato={'ciudad'} {...props}
                                   opciones={obtenerCiudades(departamento)} requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Barrio o Localidad'}
                                  dato={'barrio'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Dirección'} dato={'direccion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={4}  nombre={'Indicaciones adiciónales'} dato={'indicaciones'} {...props} />
                </Grid>



            </Grid>



        </form>

    )

}
export default Formulario_Direccion_Entrega